import React from "react";

import { Badge, Dropdown, Image } from "react-bootstrap";
import { Table } from "react-bootstrap";

// import CardDropdown from "../../components/CardDropdown";

const TableRow = ({
  data,
  sr,
  viewEntry,
  updateEntry,
  deleteEntry,
  propLength,
}) => {
  return (
    <tr className="align-middle">
      <td className="text-center" style={{ minWidth: "180px" }}>
        {data.profile_img ? (
          <Image
            src={data.profile_img}
            alt={data.name}
            thumbnail
            style={{ width: 60, height: 60, objectFit: "cover" }}
          />
        ) : (
          <span className="text-muted">No Image</span>
        )}
      </td>
      <td className="fw-semibold text-center" style={{ minWidth: "180px" }}>{data.name}</td>
      <td className="text-center" style={{ minWidth: "180px" }}>{data.role}</td>
      <td style={{ maxWidth: "300px" }}>
        <div className="text-truncate" style={{ maxWidth: 280 }}>
          {data.text_description}
        </div>
      </td>
      <td className="text-center" style={{ minWidth: "180px" }}>
        {data.status && <Badge bg="success">Active</Badge>}
        {!data.status && <Badge bg="warning">Inactive</Badge>}
      </td>
      <td className="fw-semibold text-center">{data.order}</td>

      <td className="text-center" style={{ minWidth: "180px" }}>
        {/* <span style={{ cursor: "pointer" }} onClick={() => viewEntry(data)}>
          <i className={"bi bi-eye text-info me-2"}></i>
        </span> */}
        <span style={{ cursor: "pointer" }} onClick={() => updateEntry(data)}>
          <i className={"bi bi-pen text-warning me-2"}></i>
        </span>
        <span style={{ cursor: "pointer" }} onClick={() => deleteEntry(data)}>
          <i className={"bi bi-trash text-danger"}></i>
        </span>
        {/* <CardDropdown>
          <div className="py-2">
            <Dropdown.Item
              className="text-primary"
              onClick={() => updateEntry(data)}
            >
              Edit
            </Dropdown.Item>
          </div>
        </CardDropdown> */}
      </td>
    </tr>
  );
};

const TestimonialsTable = ({
  list = [],
  viewEntry,
  updateEntry,
  deleteEntry,
}) => {
  let i = 1;
  return (
    <Table responsive hover bordered style={{ fontSize: "14px" }}>
      <thead>
        <tr>
          <th style={{ width: "80px" }}>Image</th>
          <th>Name</th>
          <th>Role</th>
          <th>Description</th>
          <th style={{ width: "120px" }}>Status</th>
          <th style={{ width: "120px" }}>Order</th>
          <th style={{ width: "120px" }}>Actions</th>
        </tr>
      </thead>
      <tbody>
        {list?.map((entry, index) => (
          <TableRow
            data={entry}
            key={index}
            sr={i++}
            propLength={list?.length}
            viewEntry={viewEntry}
            updateEntry={updateEntry}
            deleteEntry={deleteEntry}
          />
        ))}
      </tbody>
    </Table>
  );
};

export default TestimonialsTable;
